var map = {
	"./DF-logo.png": 66,
	"./DFDC-logo.png": 2234,
	"./DFDG-logo.png": 8283,
	"./DL-logo.png": 317,
	"./FF-logo.png": 5912,
	"./GF-logo.png": 2792,
	"./JJBX-logo.png": 9029,
	"./JJBXG-logo.png": 278,
	"./MVP-logo.png": 2612,
	"./TCJL-logo.png": 2061,
	"./YCS-logo.png": 1371
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5800;